module.exports = __webpack_public_path__ + "static/img/gx2.8041522.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/gx2.png
// module id = FT49
// module chunks = 1